import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'remove-connected-device-dialog',
    imports: [MatDialogModule, MatButtonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
    <h2 mat-dialog-title>{{ "REMOVE_DEVICE" | translate }}</h2>
    <mat-dialog-content>
        {{ "REMOVE_DEVICE_CONFIRM" | translate }}
        "{{ data.deviceName || data.deviceId }}"?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button class="btn btn-outline-dark mr-2" (click)="onCancel()">{{ "CANCEL" | translate }}</button>
      <button class="btn btn-outline-danger" (click)="onConfirm()">{{ "DELETE" | translate }}</button>
    </mat-dialog-actions>
  `
})
export class RemoveConnectedDeviceDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoveConnectedDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deviceName?: string; deviceId: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}